import { openExternal } from '../lib/tg';
import { useStore } from '../lib/store';

const CHANNEL_URL = 'https://t.me/estate5rp';

/** Full-screen farewell shown to every non-admin once the bot is closed. The
 *  app itself is no longer reachable; admins get a way back into the panel. */
export function ClosedScreen({ isAdmin }: { isAdmin: boolean }): JSX.Element {
  const setTab = useStore((s) => s.setTab);

  return (
    <div className="flex h-screen flex-col bg-bg text-text">
      <div className="flex flex-1 flex-col items-center justify-center overflow-y-auto px-6 py-10 text-center">
        <div
          className="mb-5 rounded-2xl p-px"
          style={{
            background:
              'linear-gradient(135deg, var(--accent), var(--accent-2), var(--neon-yellow))',
          }}
        >
          <div className="rounded-[15px] bg-bg-elev px-5 py-4">
            <div className="text-4xl leading-none">🏁</div>
          </div>
        </div>

        <h1 className="font-display text-xl">Бот закрыт</h1>

        <p className="mt-4 max-w-md text-sm text-text-dim">
          Спасибо, что пользовался — с вами это было по-настоящему приятно.
        </p>
        <p className="mt-3 max-w-md text-sm text-text-dim">
          Дома и квартиры освобождаются в 00 минут, а вики теперь обновляет данные только в 15.
          Форы, ради которой всё и делалось, больше нет — а обходить правила сервера мы не станем.
        </p>
        <p className="mt-3 max-w-md text-sm text-text-dim">
          Новые проекты по GTA5RP ещё будут. Расскажем о них в канале первыми.
        </p>

        <button
          onClick={() => openExternal(CHANNEL_URL)}
          className="mt-6 rounded-full border border-accent/40 bg-accent/10 px-5 py-2.5 text-sm font-semibold text-accent transition hover:bg-accent/20"
        >
          📣 Подписаться на канал
        </button>
      </div>

      {isAdmin && (
        <div className="border-t border-white/5 bg-bg-elev px-6 py-3">
          <button
            onClick={() => setTab('admin')}
            className="w-full rounded-md border border-white/10 px-3 py-2 text-sm text-text-dim transition hover:bg-white/5"
          >
            ⚙️ Админка
          </button>
        </div>
      )}
    </div>
  );
}
